// extracted by mini-css-extract-plugin
module.exports = {"entryLabel":"styles_entryLabel__1Hg-4","eventImage":"styles_eventImage__11yFt","titleEvent":"styles_titleEvent__3vasD","dateEvent":"styles_dateEvent__10BPl"};